module.exports = __webpack_public_path__ + "img/mountains.2c1f109b.jpg";